import { render, staticRenderFns } from "./sectionModal.vue?vue&type=template&id=a08d39a6&scoped=true&"
import script from "./sectionModal.vue?vue&type=script&lang=js&"
export * from "./sectionModal.vue?vue&type=script&lang=js&"
import style0 from "./sectionModal.vue?vue&type=style&index=0&id=a08d39a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d39a6",
  null
  
)

export default component.exports